import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const ClassSchedule = ({ classes }) => {
  const getCapacityColor = (current, max) => {
    const percentage = (current / max) * 100;
    if (percentage >= 90) return 'text-error';
    if (percentage >= 70) return 'text-warning';
    return 'text-success';
  };

  const formatTime = (time) => {
    const date = new Date(time);
    return date?.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' });
  };

  return (
    <div className="card">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-semibold text-foreground">Today's Classes</h2>
        <button className="text-sm text-primary hover:text-primary/80 transition-colors">
          Full Schedule
        </button>
      </div>
      <div className="space-y-4">
        {classes?.map((classItem) => (
          <div
            key={classItem?.id}
            className="p-4 rounded-lg bg-muted/30 hover:bg-muted/50 transition-colors"
          >
            <div className="flex items-start gap-4">
              <div className="flex-shrink-0">
                <Image
                  src={classItem?.trainerAvatar}
                  alt={classItem?.trainerAvatarAlt}
                  className="w-12 h-12 rounded-full object-cover"
                />
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-start justify-between gap-2 mb-2">
                  <div>
                    <h3 className="text-sm font-semibold text-foreground mb-1">
                      {classItem?.name}
                    </h3>
                    <p className="text-xs text-muted-foreground">
                      with {classItem?.trainer}
                    </p>
                  </div>
                  <span className={`text-xs font-medium px-2 py-1 rounded-full ${
                    classItem?.status === 'upcoming' ?'bg-primary/10 text-primary' 
                      : classItem?.status === 'ongoing' ?'bg-success/10 text-success' :'bg-muted text-muted-foreground'
                  }`}>
                    {classItem?.status}
                  </span>
                </div>

                <div className="flex items-center gap-4 text-xs text-muted-foreground mb-3">
                  <span className="flex items-center gap-1">
                    <Icon name="Clock" size={12} />
                    {formatTime(classItem?.startTime)} - {formatTime(classItem?.endTime)}
                  </span>
                  <span className="flex items-center gap-1">
                    <Icon name="MapPin" size={12} />
                    {classItem?.room}
                  </span>
                </div>

                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    <Icon name="Users" size={14} className={getCapacityColor(classItem?.currentCapacity, classItem?.maxCapacity)} />
                    <span className={`text-xs font-medium ${getCapacityColor(classItem?.currentCapacity, classItem?.maxCapacity)}`}>
                      {classItem?.currentCapacity}/{classItem?.maxCapacity}
                    </span>
                  </div>

                  <div className="flex items-center gap-2">
                    <button className="p-1.5 rounded hover:bg-muted transition-colors focus-ring">
                      <Icon name="UserPlus" size={16} color="var(--color-primary)" />
                    </button>
                    <button className="p-1.5 rounded hover:bg-muted transition-colors focus-ring">
                      <Icon name="MoreVertical" size={16} />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ClassSchedule;